import React from 'react'
import Rainbow from '../hoc/Rainbow'

const Contact = (props) =>{


    return (
        <div className="container">
            <h4 className="center">Contact</h4>
            <p>Labore cillum aliqua dolore consectetur nostrud laboris voluptate quis ut reprehenderit quis duis excepteur. Cupidatat reprehenderit ad veniam quis incididunt. Commodo aute officia pariatur exercitation culpa anim deserunt ea labore aliqua cillum ut commodo consectetur. Nostrud elit qui deserunt anim aliqua velit mollit anim nostrud aliquip incididunt nisi. Eu aliqua ullamco sit incididunt quis sunt mollit eiusmod nulla non labore et culpa.</p>
        </div>
    )
}

export default Rainbow(Contact)